// Utility: generate wa.me template links for WhatsApp click-to-chat notifications.
// This is a "manual send" approach — admin clicks link → WhatsApp opens with pre-filled message.
// No external integration required; production upgrade path = swap to Twilio/Fonnte via backend.

export function normalizePhone(raw) {
  if (!raw) return "";
  let n = String(raw).replace(/\D/g, "");
  if (n.startsWith("0")) n = "62" + n.slice(1);
  if (n.startsWith("620")) n = "62" + n.slice(3);
  if (!n.startsWith("62")) n = "62" + n;
  return n;
}

export function waLink(phone, message) {
  const n = normalizePhone(phone);
  if (!n) return "";
  return `https://wa.me/${n}?text=${encodeURIComponent(message || "")}`;
}

// Pre-composed templates for common flows (Bahasa Indonesia)
export const waTemplates = {
  newFileForClient: (client, bookingCode) =>
    `Halo ${client}, ada file baru di Portal Klien untuk booking ${bookingCode}. Silakan cek di https://booking-hub-1075.preview.emergentagent.com/portal dan konfirmasi apabila sudah sesuai. Terima kasih — Dessy Wedding Group.`,
  approvalRequest: (client, bookingCode, itemName) =>
    `Halo ${client}, mohon persetujuan Anda untuk ${itemName} pada booking ${bookingCode}. Login ke Portal Klien: https://booking-hub-1075.preview.emergentagent.com/portal. Terima kasih.`,
  newInquiryForSales: (leadName, packageName, budget) =>
    `Inquiry baru dari ${leadName || "calon klien"}. Paket: ${packageName || "-"}. Budget: ${budget || "-"}. Follow-up secepatnya ya!`,
  paymentReminder: (client, bookingCode, amount, dueDate) =>
    `Halo ${client}, mengingatkan pembayaran booking ${bookingCode} sebesar ${amount} jatuh tempo ${dueDate}. Terima kasih.`,
  quotationSent: (client, quotationCode) =>
    `Halo ${client}, penawaran ${quotationCode} sudah kami kirim. Silakan cek di Portal Klien atau hubungi kami untuk info lebih lanjut. Terima kasih.`,
};
